const COUPON_POOL_DICT: Record<string, string> = {
  welcome: 'Bronze',
  loyalty_threshold_1: 'Silver',
  loyalty_threshold_2: 'Gold',
  loyalty_threshold_3: 'Elite',
};

const mapCouponPoolName = (couponPoolName: string) =>
  COUPON_POOL_DICT[couponPoolName] || couponPoolName;

export default mapCouponPoolName;
